module.exports = __webpack_public_path__ + "static/media/cy-lab-hot.1c49ebc4.png";